import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-brush",
  "use": "icon-brush-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-brush\"><defs><style>#icon-brush .a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}</style></defs><path class=\"a\" d=\"M1.382 22.522a.552.552 0 01.03-1.01c2.629-1.065 1.781-4.062 2.563-5.664a3.931 3.931 0 015.22-1.8c5.869 2.867-1.117 11.661-7.813 8.474zM13.889 14.1l8.778-11.116a1.353 1.353 0 00-2.018-1.8l-9.892 9.866\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/icon-brush.svg
// module id = VmcX
// module chunks = 39 44